{
  "dropzoneLabel": "DropZone",
  "selectPlaceholder": "Επιλέξτε ένα αντικείμενο",
  "tableResizer": "Αλλαγή μεγέθους"
}
